import { render, staticRenderFns } from "./RisksVEList.vue?vue&type=template&id=1b60fbe7&"
import script from "./RisksVEList.vue?vue&type=script&lang=js&"
export * from "./RisksVEList.vue?vue&type=script&lang=js&"
import style0 from "./RisksVEList.vue?vue&type=style&index=0&id=1b60fbe7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports